import { RouteRecallRevertedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import getAppEnv from '../../utils/getAppEnv';
import RouteOverviewQuery from '../../queries/routes/RouteOverviewQuery';
import { recallRevertedNotification } from '../../../../notifications/routes/unpublishRoute';

/**
 * A route the planner unpublished has gone back to the driver, because the work they queued while
 * offline has arrived and proves they were already running it. The planner has to be told: they
 * believe the route is theirs to re-plan, and it is not.
 */
export default ({ route, store }: RouteRecallRevertedDtoModelType) => () => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;

  if (route?.uuid != null) {
    getAppEnv(store).notification(recallRevertedNotification(route.uuid, route.name));
  }

  if (projectId != null && route?.id != null && rootStore.ui.selectedRoute?.id === route.id) {
    store.queryRouteById({ projectId, routeId: route.id }, RouteOverviewQuery);
  }
};
